import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { revalidationApiKey } from 'constants/envConfig';
import { RevalidatePageParams } from 'types/client-template';

export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
    build.mutation<void, RevalidatePageParams>({
        query: (params) => ({
            url: `https://${params.domainName}/api/revalidate`,

            method: 'POST',
            body: {
                paths: params.paths,
            },
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': revalidationApiKey,
            },
        }),
    });
